"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var UserInfoConverter_1 = require("../../user/conversions/UserInfoConverter");

var CoordinatorFlags_1 = require("../model/CoordinatorFlags");

var CoordinatorFlagsConverter_1 = require("./CoordinatorFlagsConverter");
/**
 * Default implementation of CoordinatorFlagsConverter.
 *
 * @author ZSr
 * @author Tomas Leity
 */


var CoordinatorFlagsConverterImpl =
/*#__PURE__*/
function (_CoordinatorFlagsConv) {
  _inherits(CoordinatorFlagsConverterImpl, _CoordinatorFlagsConv);

  /**
   * @param userInfoConverter
   */
  function CoordinatorFlagsConverterImpl(userInfoConverter) {
    var _this;

    _classCallCheck(this, CoordinatorFlagsConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CoordinatorFlagsConverterImpl).call(this));
    _this.userInfoConverter = userInfoConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(CoordinatorFlagsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new CoordinatorFlags_1.CoordinatorFlags(CoordinatorFlags_1.CoordinatorFlags.schema.coordinatorAgreed.valueOf(source.coordinatorAgreed), CoordinatorFlags_1.CoordinatorFlags.schema.coordinatorAgreedAt.valueOf(source.coordinatorAgreedAt ? conversions.toDate(source.coordinatorAgreedAt) : null), CoordinatorFlags_1.CoordinatorFlags.schema.coordinator.valueOf(source.coordinator ? this.userInfoConverter.toObject(source.coordinator, conversions) : null), CoordinatorFlags_1.CoordinatorFlags.schema.approvedPromoVolume.valueOf(source.approvedPromoVolume ? conversions.toBigNumber(source.approvedPromoVolume) : null), CoordinatorFlags_1.CoordinatorFlags.schema.approvedSystemVolume.valueOf(source.approvedSystemVolume ? conversions.toBigNumber(source.approvedSystemVolume) : null), CoordinatorFlags_1.CoordinatorFlags.schema.created.valueOf(conversions.toDate(source.created)), CoordinatorFlags_1.CoordinatorFlags.schema.createdBy.valueOf(source.createdBy ? this.userInfoConverter.toObject(source.createdBy, conversions) : null));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, {
        coordinatorAgreed: source.coordinatorAgreed,
        coordinatorAgreedAt: source.coordinatorAgreedAt ? conversions.fromDate(source.coordinatorAgreedAt) : null,
        coordinator: source.coordinator ? this.userInfoConverter.toDocument(source.coordinator, conversions) : null,
        approvedPromoVolume: source.approvedPromoVolume ? conversions.fromBigNumber(source.approvedPromoVolume) : null,
        approvedSystemVolume: source.approvedSystemVolume ? conversions.fromBigNumber(source.approvedSystemVolume) : null,
        created: conversions.fromDate(source.created),
        createdBy: source.createdBy ? this.userInfoConverter.toDocument(source.createdBy, conversions) : null
      });
      return result;
    }
  }]);

  return CoordinatorFlagsConverterImpl;
}(CoordinatorFlagsConverter_1.CoordinatorFlagsConverter);

CoordinatorFlagsConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __metadata("design:paramtypes", [UserInfoConverter_1.UserInfoConverter])], CoordinatorFlagsConverterImpl);
exports.CoordinatorFlagsConverterImpl = CoordinatorFlagsConverterImpl;